import axios from 'axios';
import { IEvent, IEventCollectionDto, IEventListParams, IEventPayload } from 'entities/Events/Event.models';

const basePath = '/events';
const actionPath = '/action';

export const eventService = {
  getEventList: (params: IEventListParams): Promise<IEventCollectionDto> => axios.get(`${basePath}`, { params }),
  getEventById: (id: number): Promise<IEvent> => axios.get(`${basePath}/review/${id}`),
  reviewEvent: (id: number): Promise<IEvent> => axios.patch(`${actionPath}/review/${id}`),
  moveEventToInbox: (id: number): Promise<IEvent> => axios.patch(`${actionPath}/return/${id}`),
  completeEvent: ({ id, text }: IEventPayload): Promise<IEvent> => axios.patch(`${actionPath}/complete/${id}`, { text }),
};
